export { default as Foodware } from './foodware';
